var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18387",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18387",
    transform: "translate(-32 -282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18035",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18035",
    transform: "translate(0.729 2.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13652",
    "data-name": "\\u30D1\\u30B9 13652",
    d: "M-1380.552,4092.12v6.137a1.935,1.935,0,0,0,1.935,1.936h14.67a1.935,1.935,0,0,0,1.935-1.936v-6.137Zm4.838,3.653h-2.4v-1.367h2.4Z",
    transform: "translate(1412.553 -3804.622)",
    fill: "#A59785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13653",
    "data-name": "\\u30D1\\u30B9 13653",
    d: "M-1362.012,4090.6v-1.2a1.935,1.935,0,0,0-1.935-1.935h-14.67a1.935,1.935,0,0,0-1.935,1.935v1.2Z",
    transform: "translate(1412.553 -3804.473)",
    fill: "#A59785"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_11072",
    "data-name": "\\u9577\\u65B9\\u5F62 11072",
    width: 20,
    height: 20,
    transform: "translate(32 282)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card_icon.2a75399d45a5e38cdc71fe216b3655a9.svg";
export { ForwardRef as ReactComponent };